/** Old redux-state-sync receivers must not consume actions for a replaced store. */
export function createActiveStateSyncScope(excludedTypes) {
  let active = true;
  const excluded = new Set(excludedTypes);
  return {
    predicate: (action) => active && !excluded.has(action.type),
    deactivate() {
      active = false;
    },
  };
}
